import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';

import {ellipsis} from 'ellipsed';
import {register} from '../vendor/theme-scripts/theme-sections';
import {swatchSection} from '../features/swatch';
import {modal} from '../util/modal';
import Media from '../features/media';
import {tooltipSection} from '../features/tooltip';
import {productPhotoswipeZoom} from '../features/load-photoswipe';


const selectors = {
  productJson: '[data-bundle-product-json]',
  popupButton: '[data-toggle-product-modal]',
  zoomButton: '[data-zoom-button]',
};


const sections = [];

function getProductObject(productId) {
  if( $(`[data-product-json="${productId}"]`).length ) {
    return JSON.parse( $(`[data-product-json="${productId}"]`).html() );
  }
  return false;
}

function getVariantObject(productId, variantId) {
  if( !$(`[data-product-json="${productId}"]`).length ) {
    return false;
  }
  let productObject =  JSON.parse( $(`[data-product-json="${productId}"]`).html() );
  for( let i=0 ; i<productObject.variants.length ; i++ ) {
    if( productObject.variants[i].id == variantId ) {
      return productObject.variants[i];
    }
  }
  return false;
}

class ProductBundleTemplate {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
    this.settings = section.settings;

    // modal(this.id);
    // this.media = new Media(section);

    this.init();
  }


  init() {
    let $container = $(this.container),
        scope = this,
        $addToCartBtn = $container.find(`[data-add-to-cart]`),
        // discountCode = $container.attr('data-discount-code') || false;
        discountCode = false;

    $container.find(`[data-product-bundle-selector]`).change(function(){
      let index = $(this).closest('[data-product-bundle-list-item]').attr('data-index'),
          productId = parseInt( $(this).find(`option:selected`).attr('data-product-id') ),
          product = getProductObject(productId);
      scope.updateImage(product);
      scope.updatePrice();
    });

    $container.find(`[data-variant-selector]`).change(function(){
      scope.updatePrice();
    });

    $container.find(`[data-add-to-cart]`).click(function(evt){
      evt.preventDefault();
      $addToCartBtn.addClass('loading');

      let addItems = {
        items: [
        //   {
        //     quantity: 1,
        //     id: scope.product.variants[0].id ,
        //     properties: {}
        //   }
        ]
      };

      $container.find(`[data-product-bundle-list-item]`).each(function(){
        let quantity = 1,
            $selectedVariantInput = $(this).find(`[data-product-bundle-selector] option:checked`),
            productId = parseInt( $selectedVariantInput.attr('data-product-id') ),
            variantId = parseInt( $selectedVariantInput.val() ),
            product = getProductObject(productId),
            variant = getVariantObject(productId, variantId);
        addItems.items.push({
          quantity: quantity,
          id: variantId,
          properties: {
            '_bundle': true
          }
        });
      });
      addItems.items.reverse();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: addItems,
        error: function(){
          $addToCartBtn.removeClass('loading')
        },
        success: function(){
          $addToCartBtn.removeClass('loading')
        },
        complete: function(){
          $addToCartBtn.removeClass('loading')
          if( discountCode ) {
            window.location.href = `/checkout?discount=${discountCode}`
          } else {
            window.location.href = '/cart'
          }
        }
      });
    });

    $container.find(`[data-product-bundle-selector]`).each(function(){
      $(this).change();
    })
  }

  updatePrice() {
    let totalPrice = 0,
        totalCompareAtPrice = 0,
        discountPercentage = parseInt( $(this.container).attr('data-discount-percentage') ) || 0;

    $(`[data-product-bundle-list-item]`).each(function(){
      let bundleIndex = $(this).attr('data-index'),
          $selectedVariantInput = $(this).find(`[data-product-bundle-selector] option:checked`),
          productId = parseInt( $selectedVariantInput.attr('data-product-id') ),
          variantId = parseInt( $selectedVariantInput.val() ),
          variant = getVariantObject(productId, variantId),
          variantPrice =  variant.price,
          variantCompareAtPrice = variant.compare_at_price;

      let discountAmount = variantPrice * discountPercentage / 100;
      totalPrice += variantPrice - discountAmount;
      totalCompareAtPrice += (variantCompareAtPrice) ? variantCompareAtPrice : variantPrice;

      let $priceEle = $(this).find(`[data-bundle-product-item-price]`);
      if( variantCompareAtPrice > variantPrice ) {
        let totalPriceOff = variantCompareAtPrice - variantPrice;
        $priceEle.html( `
          <span class="product__price">
            <span data-product-price class="product__price--sale">${formatMoney(variantPrice, theme.moneyFormat)}</span>
          </span>

          <span data-price-off class="product__price--off">
            <span data-price-off-type>Bundle Discount</span>
            <em>•</em>
            Save
            <span data-price-off-amount>${formatMoney(totalPriceOff, theme.moneyFormat)}</span>
          </span>
          ` );
        } else {
          $priceEle.html( `
          <span class="product__price">
            <span data-product-price="" class="product__price--sale">${formatMoney(variantPrice, theme.moneyFormat)}</span>
          </span>` );
        }
    });

    let $bundleTotalPrice = $(`[data-bundle-total-price]`),
        totalPriceOff = totalCompareAtPrice - totalPrice;
    if( totalPriceOff > 0 ) {
      $bundleTotalPrice.html( `
      <span class="product__price">
        <span data-product-price class="product__price--sale">${formatMoney(totalPrice, theme.moneyFormat)}</span>
      </span>

      <span data-price-off class="product__price--off">
        <span data-price-off-type>${theme.strings.bundleSection.discountMessage}</span>
        <em>•</em>
        ${theme.strings.bundleSection.save}
        <span data-price-off-amount>${formatMoney(totalPriceOff, theme.moneyFormat)}</span>
      </span>` );
    } else {
      $bundleTotalPrice.html( `
      <span class="product__price">
        <span data-product-price class="product__price--sale">${formatMoney(totalPrice, theme.moneyFormat)}</span>
      </span>` );
    }
  }

  updateImage(product) {
    let $bundleItem = $(`[data-product-bundle-item][data-product-id="${product.id}"]`);
    if ( !$bundleItem.length ) {
      return;
    }

    let $bundleGroup = $bundleItem.closest(`[data-product-bundle-group]`),
        $image = $bundleGroup.find('.product-bundle__image'),
        imgUrl = product.featured_image
                  .replace('.jpg', '_600x.jpg')
                  .replace('.png', '_600x.png')
                  .replace('.gif', '_600x.gif');

    $image.css('background-image', `url(${imgUrl})`);
  }
}


const productBundleSection = {
  onLoad() {
    sections[this.id] = new ProductBundleTemplate(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockDeselect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
};

register('product-bundle', [productBundleSection, swatchSection]);

